import React from 'react';

interface PlansHeaderProps {
  qDiscount: number;
  yDiscount: number;
  onOpenDiscountModal: () => void;
  onOpenAddonManager: () => void;
  onCreateTier: () => void;
}

const PlansHeader: React.FC<PlansHeaderProps> = ({
  qDiscount,
  yDiscount,
  onOpenDiscountModal,
  onOpenAddonManager,
  onCreateTier,
}) => {
  return (
    <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6">
      <div className="text-left space-y-1">
        <h1 className="text-3xl font-extrabold text-slate-900 tracking-tight">Tier & Add-on Management</h1>
        <p className="text-slate-500 text-sm">Define per-workspace pricing, add-on upsells, metered billing, and volume discount rules.</p>
      </div>
      <div className="flex flex-wrap items-center gap-2.5">
        <button
          onClick={onOpenDiscountModal}
          className="flex items-center gap-1.5 px-4 py-2.5 bg-white text-slate-700 border border-slate-200 rounded-xl font-bold hover:bg-slate-50 transition-all shadow-xs active:scale-95 text-xs"
          title="Configure discounts for quarterly and annual billing"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M19 5 5 19"/><circle cx="6.5" cy="6.5" r="2.5"/><circle cx="17.5" cy="17.5" r="2.5"/>
          </svg>
          Billing Discounts ({qDiscount}% / {yDiscount}%)
        </button>
        <button
          onClick={onOpenAddonManager}
          className="flex items-center gap-1.5 px-4 py-2.5 bg-white text-slate-700 border border-slate-200 rounded-xl font-bold hover:bg-slate-50 transition-all shadow-xs active:scale-95 text-xs"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
          </svg>
          Manage Add-ons
        </button>
        <button
          onClick={onCreateTier}
          className="flex items-center gap-2 px-5 py-2.5 bg-indigo-600 text-white rounded-xl font-bold hover:bg-indigo-700 transition-all shadow-lg shadow-indigo-100 active:scale-95 text-xs"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="12" y1="5" x2="12" y2="19" />
            <line x1="5" y1="12" x2="19" y2="12" />
          </svg>
          New Workspace Tier
        </button>
      </div>
    </div>
  );
};

export default PlansHeader;
